function charToValue(char) {
  return char.charCodeAt(0) - 48
}

function validate(cnpj) {
  // eslint-disable-next-line no-param-reassign
  cnpj = String(cnpj).replace(/[^A-Za-z0-9]/g, '').toUpperCase()

  const pesosDigito1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const pesosDigito2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  // eslint-disable-next-line no-use-before-define
  return verificacaoGeral(cnpj) && verificarDigito(cnpj, pesosDigito1) && verificarDigito(cnpj, pesosDigito2)
}

function verificacaoGeral(cnpj) {
  if (cnpj === '') return false
  if (cnpj.length !== 14) return false
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false
  if (/^(.)\1+$/.test(cnpj)) return false

  return true
}

function verificarDigito(cnpj, pesos) {
  const acumuladora = cnpj.slice(0, pesos.length).split('')
    .reduce((anterior, atual, index) => anterior + (charToValue(atual) * pesos[index]), 0)
  const resto = acumuladora % 11
  const digito = resto < 2 ? 0 : 11 - resto
  return parseInt(cnpj[pesos.length], 10) === digito
}

export default validate
